import React from 'react';
import Popover from 'material-ui/Popover';
import classnames from 'classnames';
import './PopoverContainer.styl';

// This is intended for tooltips that are 'hoverable'.  Meaning, you can hover over them
// and the tooltip will persist.
export default class PopoverContainer extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.state = {};

    this.closePopups = this.closePopups.bind(this);
    this.scrollHandler = this.scrollHandler.bind(this);
  }

  registerPopoverItem(ref, content, anchor) {
    anchor = anchor || ref;
    if (!ref) {
      return;
    }
    // if we are registering new popover items, let's close any existing popovers
    this.closePopups(0);
    ref.addEventListener('mouseenter', () => {
      clearTimeout(this.mouseLeaveTimeout);
      this.setState({content, hoveredEl: ref, anchor});
    });
    ref.addEventListener('mouseleave', () => {
      this.closePopups(200);
    });
  }

  closePopups(timeout = 0) {
    // if we are registering new popover items, let's close any existing popovers
    clearTimeout(this.mouseLeaveTimeout);
    this.mouseLeaveTimeout = setTimeout(
      () => this.setState({content: null, hoveredEl: null, anchor: null}),
      0
    );
  }

  scrollHandler(event) {
    this.closePopups(0);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollHandler);
    clearTimeout(this.mouseLeaveTimeout);
  }

  onMouseOverPopover = () => {
    clearTimeout(this.mouseLeaveTimeout);
  };

  onMouseLeavePopover = () => {
    this.mouseLeaveTimeout = setTimeout(
      () => this.setState({content: null, hoveredEl: null, anchor: null}),
      200
    );
  };

  render() {
    const {
      anchorOriginHorizontal = 'middle',
      anchorOriginVertical = 'top',
      targetOriginHorizontal = 'middle',
      targetOriginVertical = 'bottom',
      canAutoPosition = false,
      hideEmpty = false,
      hoveredEl: propsHoveredEl,
      anchor: propsAnchor,
      content: propsContent,
    } = this.props;
    const {hoveredEl: stateHoveredEl, anchor: stateAnchor, content: stateContent} = this.state;
    const hoveredEl = propsHoveredEl ? propsHoveredEl : stateHoveredEl;
    const anchor = propsAnchor ? propsAnchor : stateAnchor;
    const content = propsAnchor ? propsContent : stateContent ? stateContent() : null;
    const tooltipClassName = this.props.className || 'ev-tooltip-control ev-tooltip';
    const containerClassName = classnames(
      'tooltip-container',
      {
        'no-tail': this.props.noTail,
      },
      [this.props.containerClassName]
    );
    if (hoveredEl) {
      return (
        (content || !hideEmpty) && (
          <Popover
            className="destyle-popover"
            canAutoPosition={canAutoPosition}
            open={true}
            useLayerForClickAway={false}
            anchorEl={anchor}
            anchorOrigin={{
              horizontal: anchorOriginHorizontal,
              vertical: anchorOriginVertical,
            }}
            targetOrigin={{
              horizontal: targetOriginHorizontal,
              vertical: targetOriginVertical,
            }}>
            <div
              className={containerClassName}
              onMouseOver={this.onMouseOverPopover}
              onMouseLeave={this.onMouseLeavePopover}>
              <div className={tooltipClassName}>
                <div className="tooltip-content">{content}</div>
              </div>
            </div>
          </Popover>
        )
      );
    }
    return null;
  }
}
